export const profileApplyStepPlan = [
  {
    id: 'loadProfile',
    label: 'Load profile',
    detail: 'Selected mapping profile settings',
  },
  {
    id: 'inspectProject',
    label: 'Inspect project',
    detail: 'Read active Revit project parameters before setup changes.',
  },
  {
    id: 'buildRepairPlan',
    label: 'Plan setup changes',
    detail: 'Compare missing setup areas and choose the required changes.',
  },
  {
    id: 'connectorRepair',
    label: 'Connector setup',
    detail: 'Connector setup; skipped if already complete.',
  },
  {
    id: 'quickFillRepair',
    label: 'Quick Fill setup',
    detail: 'Quick Fill setup values before family setup; skipped if not needed.',
  },
  {
    id: 'boltRepair',
    label: 'Bolt setup',
    detail: 'Selected bolt-property setup; skipped if already complete.',
  },
  {
    id: 'additionalCategoryRepair',
    label: 'Additional-category setup',
    detail: 'Additional-category setup; skipped if already complete.',
  },
  {
    id: 'finalizeFamilySetup',
    label: 'Finalize family setup',
    detail: 'Apply connector setup to families introduced during setup.',
  },
  {
    id: 'processProjectRepair',
    label: 'Process and project setup',
    detail: 'Process and project setup; skipped if already complete.',
  },
  {
    id: 'verifyProject',
    label: 'Check project parameters',
    detail: 'Confirm that required mapping setup exists.',
  },
] as const;

export type ProfileApplyStepId = (typeof profileApplyStepPlan)[number]['id'];

export const childRepairStepIdMap: Record<string, ProfileApplyStepId> = {
  connector: 'connectorRepair',
  connectorRepair: 'connectorRepair',
  processProject: 'processProjectRepair',
  processProjectRepair: 'processProjectRepair',
  quickFill: 'quickFillRepair',
  quickFillRepair: 'quickFillRepair',
  bolt: 'boltRepair',
  boltRepair: 'boltRepair',
  additional: 'additionalCategoryRepair',
  additionalRepair: 'additionalCategoryRepair',
  additionalCategoryRepair: 'additionalCategoryRepair',
  connectorFinalization: 'finalizeFamilySetup',
  finalizeFamilySetup: 'finalizeFamilySetup',
  verify: 'verifyProject',
  verifyProject: 'verifyProject',
};

export const repairStepIds: ProfileApplyStepId[] = [
  'connectorRepair',
  'quickFillRepair',
  'boltRepair',
  'additionalCategoryRepair',
  'finalizeFamilySetup',
  'processProjectRepair',
];

export const runningStepMessages: Record<ProfileApplyStepId, string> = {
  loadProfile: 'Loading mapping profile settings',
  inspectProject: 'Checking Revit project parameters before setup changes',
  buildRepairPlan: 'Planning the required setup changes',
  connectorRepair: 'Creating connector parameters',
  processProjectRepair: 'Creating process and project parameters',
  quickFillRepair: 'Applying Quick Fill setup',
  boltRepair: 'Creating bolt parameters',
  additionalCategoryRepair: 'Creating additional-category parameters',
  finalizeFamilySetup: 'Applying connector setup to newly introduced families',
  verifyProject: 'Revit is checking project parameters after setup changes',
};

export function getProfileApplyStepIndex(stepId: ProfileApplyStepId): number {
  return profileApplyStepPlan.findIndex((step) => step.id === stepId);
}

export function isProfileApplyStepId(stepId: string): stepId is ProfileApplyStepId {
  return profileApplyStepPlan.some((step) => step.id === stepId);
}

